import axios from 'axios';

export const getExternal = async (url: string) : Promise<any> => {
    const response = await axios.get(url);
    
    return response.data;
}

export const postExternal = async (url: string, postObject: any) : Promise<any> => {
    const response = await axios.post(url, postObject);
    
    return response.data;
}

